
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {useRouter} from "vue-router";
import {column} from "@/assets/types/common";
const orderStatusNav: Array<{ name: string; id: number }> = [
    {
        name: "菜单设置",
        id: 0,
    },
    {
        name: "文章管理",
        id: 1,
    }
];
const columnList:Array<column> = [
    {
        prop: "menu_name",
        label: "一级菜单",
        width: 170,
    },
    {
        prop: "name",
        label: "名称",
        width: 170,
    },
    {
        prop: "hypeLink",
        label: "链接",
        width: 170,
    },
    {
        prop: "desc",
        label: "",
        width: 300,
    }
];
export default defineComponent({
    name: "wechatMenu",
    setup(){
        const setTitle: any = inject("setTitle");
        setTitle(['微信菜单']);
        const Router = useRouter();
        let orderStatus = ref(0),
            headClass = inject("headClass"),
            loading = ref(false),
            screenParameter = reactive({
                page:1,
                pagesize:10,
                status:orderStatusNav[orderStatus.value].id,
            }),
            configData = reactive({
                firstMenu:['使用二级菜单','手动输入','门店导航','会员中心','服务预约','违章查询'],
                secondaryMenu:['手动输入','门店导航','会员中心','服务预约','违章查询'],
                tableData:[] as any
            });
        let getTableData = () => {
            configData.firstMenu = ['使用二级菜单','手动输入','门店导航','会员中心','服务预约','违章查询'];
            configData.secondaryMenu = ['手动输入','门店导航','会员中心','服务预约','违章查询'];
            configData.tableData = [
                {
                    id:2,
                    name:"门店导航",
                    link:"www.baidu.com",
                    subData:[]
                },
                {
                    id:3,
                    name:"会员中心",
                    link:"www.google.com",
                    subData:[]
                },
                {
                    id:0,
                    name:"更多服务",
                    link:"www",
                    subData:[
                        {
                        
                        }
                    ]
                },
            ];
        };
        onMounted(()=> {
        
        });
        watch(orderStatus,(newValue, oldValue) => {
            screenParameter.status = orderStatusNav[newValue].id;
            getTableData();
        });
        return {
            orderStatusNav,
            orderStatus,
            screenParameter,
            configData,
            headClass,
            loading,
            columnList
        }
    }
})
